import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import bigHouseLogo from '../Assets/images/Gap-Realty.png';
import BookScheduleModal from "./Forms/BookSchedule";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);


  useEffect(() => {
    if (!isHome) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  const handleNav = (path) => {
    navigate(path);
    setIsDrawerOpen(false);
  };

  const openSchedule = () => {
    setIsScheduleOpen(true);
  };

  const closeSchedule = () => {
    setIsScheduleOpen(false);
  };

  return (
    <>
      <header className={`big-house-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="big-house-header-container">
          <div className="big-house-logo" onClick={() => navigate("/")}>
            <img src={bigHouseLogo} alt="Gap Realty India Logo" />
          </div>
          {/* onClick={() => handleNav("/about-us")}
onClick={() => handleNav("/our-services")}
onClick={() => handleNav("/my-projects")}
onClick={() => handleNav("/contact-us")} */}
          <nav className="big-house-nav">
            <span onClick={() => handleNav("/")} className="big-house-header-nav">Home</span>
            <div
              className="big-house-nav-dropdown"
              // onMouseEnter={() => setIsAboutOpen(true)}
              // onMouseLeave={() => setIsAboutOpen(false)}
              onClick={() => handleNav("/about-us")}
            >
              <span className="big-house-header-nav">
                About
              </span>

              {isAboutOpen && (
                <div className="about-dropdown-box">
                  <span onClick={() => handleNav("/about-us")}>About Us</span>
                  <span onClick={() => handleNav("/management-team")}>Management Team</span>
                </div>
              )}
            </div>

            <span onClick={() => handleNav("/our-services")} className="big-house-header-nav">Services</span>
            <span onClick={() => handleNav("/my-projects")} className="big-house-header-nav">Projects</span>
            <span onClick={() => { openSchedule(); }} className="big-house-header-nav">Book Schedule</span>
            {/* <span onClick={() => handleNav("/blog")} className="big-house-header-nav">Blog</span> */}
            <span onClick={() => handleNav("/contact-us")} className="big-house-header-contact-btn">Contact</span>
          </nav>

          <div className="big-house-hamburger-icon" onClick={toggleDrawer}>
            {isDrawerOpen ? <X size={28} /> : <Menu size={28} />}
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div className={`big-house-mobile-drawer ${isDrawerOpen ? "open" : ""}`}>
        <span onClick={() => handleNav("/")}>Home</span>
        <div className="mobile-about-section" onClick={() => handleNav("/about-us")}>
          <span 
          // onClick={() => setIsAboutOpen(!isAboutOpen)}
          >About</span>

          {isAboutOpen && (
            <div className="mobile-about-dropdown">
              <span onClick={() => handleNav("/about-us")}>About Us</span>
              <span onClick={() => handleNav("/management-team")}>Management Team</span>
            </div>
          )}
        </div>

        <span onClick={() => handleNav("/our-services")}>Services</span>
        <span onClick={() => handleNav("/my-projects")}>Projects</span>
        <span onClick={() => {
          openSchedule();
          setIsDrawerOpen(false);
        }}>Book Schedule</span>
        {/* <span onClick={() => handleNav("/blog")}>Blog</span> */}
        <span
          onClick={() => handleNav("/contact-us")}
          className="big-house-header-contact-btn"
        >
          Contact
        </span>
      </div>



      <BookScheduleModal isOpen={isScheduleOpen} closeSchedule={closeSchedule} />
    </>
  );
};

export default Header;
